// Education3.jsx

import React, { useState } from "react";
import DigilockerPopup from "./digilockerPopup";
// import ABMonthYear from "./ABMonthYear";
import Dropdown from "./Dropdown";
import TextInput from "./TextInput";
import LocationInput from "./LocationInput";
import Degree from "./Documents/Degree";
import Marksheet from "./Documents/Marksheet";

const Education3 = (props) => {
  // const { key, value, caseCheckId, newRecord, selectHandler } = props;
  const [qualificationDegree, setQualificationDegree] = useState("");
  const [institution, setInstitution] = useState("");
  const [qualification, setQualification] = useState("");
  const [courseName, setCourseName] = useState("");
  const [modeOfQualification, setModeOfQualification] = useState("");
  const [location, setLocation] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    // Example validation
    if (value.trim() === "") {
      setNameError("Name is required");
    } else {
      setNameError("");
    }
  };
  const handleNext = () => {
    // Handle continue button click
    props.onNext();
  };

  return (
    <>
      <div className="row p-0 m-0 py-3">
        <h2 className="eduHeading col-12 pb-4">Education 1</h2>

        <div className="col-lg-5 col-md-6 col-sm-12">
          <Dropdown
            label="University/Board"
            options={[
              "Doctorate",
              "Post Graduate",
              "Graduate",
              "Senior Secondary (10+2)",
              "Secondary (10th)",
              "Diploma",
            ]}
            onChange={(e) => setQualificationDegree(e.target.value)}
          />
        </div>
        <div className="col-lg-7 col-md-6 col-sm-12">
          <Dropdown
            label="College/Institute/School"
            options={[
              "Doctorate",
              "Post Graduate",
              "Graduate",
              "Senior Secondary (10+2)",
              "Secondary (10th)",
              "Diploma",
            ]}
            onChange={(e) => setInstitution(e.target.value)}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Dropdown
            label="Qualification/Degree"
            options={[
              "Doctorate",
              "Post Graduate",
              "Graduate",
              "Senior Secondary (10+2)",
              "Secondary (10th)",
              "Diploma",
            ]}
            onChange={(e) => setQualification(e.target.value)}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <TextInput
            label="Course Name"
            value={name}
            onChange={handleNameChange}
            error={nameError}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Dropdown
            label="Mode Of Qualification"
            options={[
              "Correspondence",
              "Distance Learning",
              "Full time",
              "Part time",
            ]}
            onChange={(e) => setModeOfQualification(e.target.value)}
          />
        </div>
        {/* calander */}
        {/* <div className="col-lg-4 col-md-6 col-sm-12">
        <ABMonthYear
            paramStartDate={value.fields.batch_start_year.field_value}
            placeholder="Batch Start"
            name={`batchStart_${caseCheckId}`}
            id={`batchStart_${caseCheckId}`}
            fieldId={value.fields.batch_start_year.id}
            isRequired={1}
            errId={`err_${caseCheckId}_${value.fields.batch_start_year.id}`}
            dateSelect={selectHandler}
            maxDate={newRecord[value.fields.end_year.id]}
            checkDetailsIndex={key}
            fieldName="batch_start_year"
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
        <ABMonthYear
            paramStartDate={value.fields.batch_end_year.field_value}
            placeholder="Batch End"
            name={`batchStart_${caseCheckId}`}
            id={`batchStart_${caseCheckId}`}
            fieldId={value.fields.batch_end_year.id}
            isRequired={1}
            errId={`err_${caseCheckId}_${value.fields.batch_end_year.id}`}
            dateSelect={selectHandler}
            maxDate={newRecord[value.fields.end_year.id]}
            checkDetailsIndex={key}
            fieldName="batch_end_year"
          />
        </div> */}
        <div className="col-lg-4 col-md-6 col-sm-12">
          <LocationInput onChange={(e) => setLocation(e.target.value)} />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <TextInput
            label="Roll No."
            value={name}
            onChange={handleNameChange}
            error={nameError}
          />
        </div>
        <h2 className="eduHeading col-12 py-3">Documents</h2>

        {/* <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="form-group">
            <div className="floating-label tp-dropdown">
              <select
                name="qualificationDegree_2243551"
                id="qualificationDegree_2243551"
                className="form-control"
                data-checkdetailsindex="0"
                data-fieldname="qualification_degree"
              >
                <option value="">Select option</option>
                <option value="Degree">Degree</option>
                <option value="Marksheet">Marksheet</option>
                <option value="Certificate">Certificate</option>
                <option value="Provisional Certificate">Provisional Certificate</option>
                <option value="Diploma">Diploma</option>
              </select>
              <label for="qualificationDegree_2243551" className="focused">
                Document Type <sup className="text-danger">*</sup>
              </label>
            </div>
            <p className="err text-danger" id="err_2243551_134"></p>
            <input
              type="hidden"
              name="qualificationDegree_2243551_value"
              id="qualificationDegree_2243551_value"
              value=""
            />
          </div>
        </div> */}

        {/* <DigiDropdown />
        <Drpdn /> */}

        <div className="col-lg-4 col-md-6 col-sm-12">
          <Dropdown
            label="Select Document Type"
            options={[
              "Degree",
              "Marksheet",
              "Certificate",
              "Provisional Certificate",
              "Diploma",
            ]}
            onChange={(e) => setModeOfQualification(e.target.value)}
          />
        </div>

        <div className="col-12 my-2">
          <Degree />
        </div>

        <div className="col-12 my-2">
          <Marksheet />
        </div>
      </div>
    </>
  );
};

export default Education3;
